module.exports = __webpack_public_path__ + "img/img_customers_02.dbe4870b.png";